// /src/pages/AffiliatedTab.jsx

import React from 'react';
import PublicLexicalPage from '../../components/PublicLexicalPage';

function AffiliatedTab({ onTocReady, onTocVisibleChange }) {
  return (
    <PublicLexicalPage 
      documentName="Affiliate"
      layout="plain"
      onTocReady={onTocReady}
      onTocVisibleChange={onTocVisibleChange}
    />
  );
}


export default AffiliatedTab;
